import * as styles from "/tools/js/svg/templates/svg.module.scss";
const SvgGoogleBusinessProfileLogoLarge = ({ title, titleId, ...props }) => {
  props = Object.assign({}, props, {
    "aria-hidden": true,
  });
  if (!props.noAlign) {
    const className = (props.className || "") + " " + styles.alignIcon;
    props = Object.assign({}, props, {
      className,
    });
  }
  return (
    <svg
      width={100}
      height={100}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M77.897 33.468H20.35a2.476 2.476 0 0 0-2.476 2.476v41.781a2.476 2.476 0 0 0 2.476 2.476h57.548a2.476 2.476 0 0 0 2.476-2.476V35.944a2.476 2.476 0 0 0-2.476-2.476Z"
        fill="#4989F5"
      />
      <path
        d="M77.175 33.12H21.002c-1.74 0-3.094 13.466-3.094 15.206L48.67 80.204h28.505a3.173 3.173 0 0 0 3.164-3.164V36.282a3.173 3.173 0 0 0-3.164-3.163Z"
        fill="url(#src__com__yext__listingslaunchstorm__public__icons__google-business-profile-logo-large_svg__a)"
      />
      <path d="M32.144 41.295H50V17.857H34.817l-2.673 23.438Z" fill="#3C4BA6" />
      <path
        d="M67.857 41.295H50V17.857h15.183l2.674 23.438ZM80.439 22.302l.084.255c-.02-.09-.062-.174-.084-.255Z"
        fill="#7BABF7"
      />
      <path
        d="m80.397 22.38-.022-.08a5.648 5.648 0 0 0-5.514-4.443h-9.675l2.672 23.438h17.858L80.397 22.38Z"
        fill="#3F51B5"
      />
      <path
        d="m19.756 22.302-.084.255c.02-.09.061-.174.084-.255Z"
        fill="#7BABF7"
      />
      <path
        d="m19.608 22.38.022-.08a5.648 5.648 0 0 1 5.514-4.443h9.675l-2.676 23.438H14.286l5.322-18.915Z"
        fill="#7BABF7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.173 41.29a8.924 8.924 0 1 1-17.847 0h17.847Z"
        fill="#709BE0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50.02 41.29a8.924 8.924 0 1 1-17.847 0H50.02Z"
        fill="#3C4BA6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M67.868 41.29a8.924 8.924 0 1 1-17.847 0h17.847Z"
        fill="#709BE0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M85.714 41.29a8.924 8.924 0 1 1-17.847 0h17.847Z"
        fill="#3C4BA6"
      />
      <path
        d="M76.792 65.466a16.892 16.892 0 0 0-.159-1.308H66.9c0 1.361 0 2.847-.005 4.209h5.64a4.904 4.904 0 0 1-2.065 3.148s0-.024-.004-.024a5.908 5.908 0 0 1-2.283.89 6.704 6.704 0 0 1-2.47-.01 6.172 6.172 0 0 1-2.303-.998 6.427 6.427 0 0 1-2.264-2.894c-.035-.09-.067-.182-.1-.275v-.01l.008-.006a6.243 6.243 0 0 1-.003-4.017 6.464 6.464 0 0 1 1.498-2.437 6.084 6.084 0 0 1 6.13-1.597c.837.257 1.6.707 2.231 1.313l1.903-1.902c.335-.34.684-.668 1.007-1.018a10.057 10.057 0 0 0-3.333-2.064 10.478 10.478 0 0 0-7.205.023 10.418 10.418 0 0 0-5.627 5.043c-.416.824-.72 1.7-.901 2.604a10.355 10.355 0 0 0 7.466 12.043c1.724.462 3.558.45 5.296.056a9.39 9.39 0 0 0 4.239-2.203c1.25-1.151 2.148-2.685 2.618-4.314.393-1.381.535-2.82.42-4.252Z"
        fill="#fff"
      />
      <defs>
        <linearGradient
          id="src__com__yext__listingslaunchstorm__public__icons__google-business-profile-logo-large_svg__a"
          x1={17.908}
          y1={56.661}
          x2={80.338}
          y2={56.661}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.03} stopColor="#4079D8" />
          <stop offset={1} stopColor="#4989F5" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export default SvgGoogleBusinessProfileLogoLarge;
